const cards = document.querySelectorAll('.is-style-produits--single');

function isMobile() {
  return window.matchMedia('(hover: none)').matches;
}

if (isMobile()) {
  cards.forEach(clickedCard => {
    clickedCard.addEventListener('click', () => {
      // Si la carte est déjà active
      const isAlreadyActive = clickedCard.classList.contains('is-hovered');

      // On retire la classe de toutes les cartes
      cards.forEach(card => card.classList.remove('is-hovered'));

      // Si elle ne l'était pas déjà, on l'active
      if (!isAlreadyActive) {
        clickedCard.classList.add('is-hovered');
      }
    });
  });
}
